AUTHENTICATED_PLAN_SKUS